module.exports = __webpack_public_path__ + "static/media/Ellipse.8f258975.png";